import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router'
import {
  DOCUMENT_SERVER_STATUS,
  getDocumentsUrlWithCurrentParams,
  useCurrentDocument,
} from '~/entities/document'
import { useUserStore } from '~/entities/user'
import { Button, Dialog, OptiWalking, Text } from '~/shared/ui'

export function CheckDocumentAssigneeDialog() {
  const navigate = useNavigate()
  const { data } = useCurrentDocument()
  const userInfo = useUserStore((state) => state.userInfo)

  const isOtherUserAssigned = useMemo(() => {
    if (
      data.document.review_status === DOCUMENT_SERVER_STATUS.reviewed ||
      data.document.review_status === DOCUMENT_SERVER_STATUS.auto_reviewed
    ) {
      return false
    }

    return (
      data.document.reviewer?.sub &&
      userInfo?.email &&
      data.document.reviewer.sub !== userInfo.email
    )
  }, [data.document.review_status, data.document.reviewer?.sub, userInfo?.email])

  const onSubmit = useCallback(() => {
    navigate(getDocumentsUrlWithCurrentParams())
  }, [navigate])

  if (!isOtherUserAssigned) {
    return null
  }

  return (
    <Dialog
      open={isOtherUserAssigned}
      size="sm"
      onClose={onSubmit}
      actions={
        <Button
          raised
          onClick={onSubmit}
        >
          Go to queue
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <OptiWalking />
        <div className="flex flex-col gap-2">
          <Text
            className="text-text-primary"
            appearance="SUBTITLE2"
          >
            Hang tight! This one's already taken.
          </Text>
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            Looks like your teammate just started reviewing this document a few seconds ago.
            <br />
            To keep things tidy and avoid duplicate work, please return to the work queue and pick
            the next available document.
          </Text>
        </div>
      </div>
    </Dialog>
  )
}
